import './styles.css'
const PrivacyPolicyPage = () => {
  return <>
        <h1>MCQ HUB Privacy Policy</h1>
        <p>Last updated: 6 Dec 2023</p>

        <p>Thank you for choosing MCQ HUB! This Privacy Policy is designed to help you understand how we collect, use, and safeguard your personal information while using our app.</p>

        <h2>1. Information We Collect</h2>

        <h3>1.1 Personal Information:</h3>
        <p>We may collect personal information such as your name, email address, and other contact details when you register for an account or contact us for support.</p>

        <h3>1.2 Usage Information:</h3>
        <p>We gather information about how you use MCQHUB, including the content you view and interact with, device information, and other usage data.</p>

        <h2>2. How We Use Your Information</h2>

        <h3>2.1 Provide and Improve the Service:</h3>
        <p>We use your information to provide, maintain, and improve our app, ensuring a better user experience.</p>

        <h3>2.2 Communication:</h3>
        <p>We may use your email address to send you important updates, notifications, or promotional material.</p>

        <h3>2.3 Customer Support:</h3>
        <p>Your information helps us respond to your customer service requests and support needs more efficiently.</p>

        <h2>3. Data Security</h2>

        <p>We take reasonable measures to protect your personal information from unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>

        <h2>4. Third-Party Services</h2>

        <h3>4.1 Analytics:</h3>
        <p>We may use third-party analytics tools to understand how users interact with our app. These tools collect information sent by your device, including usage patterns and user demographics.</p>

        <h3>4.2 Advertising:</h3>
        <p>MCQ HUB may display third-party advertisements. Advertisers may collect information about your device and online activity to provide relevant ads.</p>

        <h2>5. Your Choices</h2>

        <p>You can control the information we collect and how it&apos;s used. Most mobile devices allow you to control or disable the use of certain features, such as location services or push notifications.</p>

        <h2>6. Changes to This Privacy Policy</h2>

        <p>We may update our Privacy Policy from time to time. You will be notified of any changes by posting the new Privacy Policy on this page.</p>

        <h2>7. Contact Us</h2>

        <p>If you have any questions or concerns about this Privacy Policy, please contact us at ankitkumar1578114@gmail.com .</p>

        <p>By using MCQ HUB, you agree to the terms outlined in this Privacy Policy.</p>
        <p>MCQ HUB Privacy Policy URL: <a href="https://mcqshub.netlify.com/privacy-policy">https://mcqshub.netlify.com/privacy-policy</a></p>

    </>
}

export default PrivacyPolicyPage
